// src/lib/dashboardApi.ts  (or wherever you put it)

import { getToken } from './auth';

const API_BASE_URL = process.env.PUBLIC_API || 'https://thequran4all.com/api';
 
export interface Slide {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  image: string;
  accent_color: string;
  bg_gradient: string;
  created_at: string;
  is_active: boolean;
}
export const fetchSlidesAll = async (): Promise<Slide[]> => {
  const response = await fetch(`${API_BASE_URL}/admin/slides?all=true`);

  if (!response.ok) {
    throw new Error("Failed to fetch slides");
  }

  const data = await response.json();
 
  // ✅ DIRECT ARRAY CASE
  if (Array.isArray(data)) {
    return data;
  }

  // ❌ REMOVE WRAPPED LOGIC (cause error)
  throw new Error("Invalid response format");
};
export const fetchSlides = async (): Promise<Slide[]> => {
  const response = await fetch(`${API_BASE_URL}/admin/slides`);

  if (!response.ok) {
    throw new Error("Failed to fetch slides");
  }

  const data = await response.json();
 
  // ✅ DIRECT ARRAY CASE
  if (Array.isArray(data)) {
    return data;
  }

  // ❌ REMOVE WRAPPED LOGIC (cause error)
  throw new Error("Invalid response format");
} 